import { render, staticRenderFns } from "./OrdersTableDesktop.vue?vue&type=template&id=aeeefb3c&scoped=true"
import script from "./OrdersTableDesktop.vue?vue&type=script&lang=js"
export * from "./OrdersTableDesktop.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=aeeefb3c&prod&scoped=true&lang=css&external"
import style1 from "./OrdersTableDesktop.vue?vue&type=style&index=1&id=aeeefb3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeefb3c",
  null
  
)

export default component.exports